import { ApiService } from './api.service';

interface LoginCredentials {
  username: string;
  password: string;
}

interface RegisterData {
  firstname: string;
  lastname: string;
  username: string;
  email: string;
  password: string;
}

export default {
  /**
   * Login user and get JWT token
   */
  login(credentials: LoginCredentials) {
    const formData = new URLSearchParams();
    formData.append('username', credentials.username);
    formData.append('password', credentials.password);

    return ApiService.postForm('api/v1/auth/token', formData);
  },

  /**
   * Register a new user
   */
  register(userData: RegisterData) {
    return ApiService.post('api/v1/auth/register', userData);
  },

  /**
   * Get current user information
   */
  getCurrentUser() {
    return ApiService.get('api/v1/auth/me');
  },

  /**
   * Update current user information
   */
  updateCurrentUser(userData: any) {
    return ApiService.put('api/v1/auth/me', userData);
  },

  /**
   * Send password reset email
   */
  sendResetEmail(email: string, config: any = {}) {
    return ApiService.post('api/v1/public/send_mail', {
      target_mail: email,
      message: 'Password reset request'
    }, config);
  },

  /**
   * Reset password (force change)
   */
  resetPassword(data: any) {
    return ApiService.put('api/v1/auth/me/reset-password', data);
  }
};